import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { TestCase } from '@/domain/value_objects/testCase/TestCase'
import { TestCaseModuleName } from '@/store/modules/modules'

export class TestCaseViewModel {
  private store = useStore()

  testCaseList: ComputedRef<TestCase[]> = computed(() => this.store.getters[`${TestCaseModuleName}/testCaseList`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${TestCaseModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${TestCaseModuleName}/error`])

  async getTestCaseList(problemId: string): Promise<void> {
    await this.store.dispatch(`${TestCaseModuleName}/getTestCaseList`, { problemId })
  }
}
